// new fullpage("#fullpage", {    
//     scrollingSpeed: 1000,
//     css3: true,
//     // autoScrolling: false,
//     // scrollOverflow:true,
//     verticalCentered: true,
//     sectionSelector: '.shopify-section'
// });
// document.addEventListener('DOMContentLoaded', function() {
//     var flkty = new Flickity( '.tabs-slider', {
//     fade: true,
//     cellAlign: 'left',
//     contain: true,
//     prevNextButtons: false,
//       draggable: true,
//       pageDots: true,
//       lazyLoad: true,
//       wrapAround: true
//   });
// }, false);
// let linkpath = window.location.pathname;
// console.log("linkpath", linkpath);
// if(linkpath.indexOf("privacy-policy") > 0){
//     console.log("product page");
//     new fullpage("#fullpage", {    
//         scrollingSpeed: 1400,
//         css3: true,
//         easing: 'easeInOutCubic',
//         easingcss3: 'ease',
//         autoScrolling: true,
//         scrollOverflow:true,
//         verticalCentered: true,
//         // normalScrollElements: '.new-review-form',
//         // scrollOverflowOptions: { click: false, preventDefaultException: { tagName: "div" } },
//        scrollOverflowOptions: {
//          click: false,
//          touchSensitivity: 5
//          // preventDefault: false
//          // disablePointer: true,
//      },
//         sectionSelector: '.scroll-section',        
//         afterReBuild: function(){
//           console.log("fullPage.js has manually being re-builded");
//         }
      
//     });
// } else if (linkpath.indexOf('review') > 0){

 

  // } else if (linkpath.indexOf('product') > 0 ){
  //   new fullpage("#fullpage", {    
  //     scrollingSpeed: 1400,
  //     css3: true,
  //     easing: 'easeInOutCubic',
  //     easingcss3: 'ease',
  //     autoScrolling: true,
  //     scrollOverflow:true,
  //     verticalCentered: true,
  //     // normalScrollElements: '.new-review-form',
  //     // scrollOverflowOptions: { click: false, preventDefaultException: { tagName: "div" } },
  //    scrollOverflowOptions: {
  //      click: false,
  //      touchSensitivity: 6
  //      // preventDefault: false
  //      // disablePointer: true,
  //  },
  //     sectionSelector: '.scroll-section',        
  //     afterReBuild: function(){
  //       console.log("fullPage.js has manually being re-builded");
  //     }
    
  // });
    // const body = document.body,
    // jsScroll = document.querySelector("#fullpage");
    // height = jsScroll.getBoundingClientRect().height - 1,
    // console.log(height);
    // speed = 0.05

    // var offset = 0

    // body.style.height = Math.floor(height) + "px"

    //   function smoothScroll() {
        
    //       offset += (window.pageYOffset - offset) * speed
          
    //       var scroll = "translateY(-" + offset + "px) translateZ(0)"
    //       jsScroll.style.transform = scroll
          
    //       raf = requestAnimationFrame(smoothScroll)
    //   }
    //   smoothScroll()
//     ele = $('#stamped-main-widget')[0];
//     let resizeObserver = new ResizeObserver(() => {
//       setTimeout(function(){fullpage_api.reBuild();}, 1000);
     
//     });
//     resizeObserver.observe(ele);

	
//  }else {
//     console.log("other page");
//     new fullpage("#fullpage", {    
//       scrollingSpeed: 1400,
//       css3: true,
//       easing: 'easeInOutCubic',
//         easingcss3: 'ease',
//       // autoScrolling: false,
//       // scrollOverflow:true,
//       verticalCentered: true,
//       touchSensitivity: 5,
//       sectionSelector: '.shopify-section'
//   });
//  }

 
$(document).ready(function(){ 
  $(".stamped-main-badge").click(function(e){
    e.preventDefault();    
    fullpage_api.moveTo(4);
  });
  $(".template-product .stamped-summary-actions-newreview").click(function(e){
    e.preventDefaut();
    window.location.href="/pages/review"
  });
});
$(document).on('click', '.template-product .stamped-summary-actions-newreview', function(e){
  e.preventDefault();
  console.log("tessetset");
  window.location.href = '/pages/review';
})
// window.addEventListener("load", (event) => {
//   let el = document.querySelector(".template-product #stamped-main-widget .stamped-summary-actions-newreview");
//   el.addEventListener('click', function(e){
//     e.preventDefault();
//     console.log("dsfsdfsf");
//   })
// });